import type { FC } from 'react';
import type { HSVA, RGBA } from '../../types';
import { InputCell } from '../InputCell';
import { ColorModel } from '../../colorModel';
import './style.less';

interface RgbaInputInterface {
  hsva: HSVA;
  onChange: (hsva: HSVA) => void;
}

export const RgbaInput: FC<RgbaInputInterface> = (props) => {
  const { hsva, onChange } = props;

  const rgba = ColorModel.toColorSet(hsva).rgba;

  const handleChange = (rgba: RGBA) => {
    const hsva = ColorModel.toColorSet(rgba).hsv;
    onChange(hsva);
  };

  return (
    <div className="rgba-container">
      <InputCell
        value={rgba.r}
        label="R"
        onChange={(r) => {
          handleChange({ ...rgba, r });
        }}
      ></InputCell>
      <InputCell value={rgba.g} label="G" onChange={(g) => handleChange({ ...rgba, g })}></InputCell>
      <InputCell value={rgba.b} label="B" onChange={(b) => handleChange({ ...rgba, b })}></InputCell>
      <InputCell
        value={Math.floor(rgba.a * 100)}
        label="A"
        max={100}
        onChange={(a) => {
          handleChange({ ...rgba, a: a / 100 });
        }}
      ></InputCell>
    </div>
  );
};
